var map = {
	"./ion-action-sheet.entry.js": [
		"9e7c",
		"chunk-643cb1fe"
	],
	"./ion-alert.entry.js": [
		"b6ad",
		"chunk-29fac282"
	],
	"./ion-app_8.entry.js": [
		"91ba",
		"chunk-33ab70c0"
	],
	"./ion-avatar_3.entry.js": [
		"9972",
		"chunk-7a95ca2d"
	],
	"./ion-back-button.entry.js": [
		"d95d",
		"chunk-4d9a47e4"
	],
	"./ion-backdrop.entry.js": [
		"090c",
		"chunk-2d0a4ef2"
	],
	"./ion-button_2.entry.js": [
		"21ee",
		"chunk-06132789"
	],
	"./ion-card_5.entry.js": [
		"ad05",
		"chunk-aa26d240"
	],
	"./ion-checkbox.entry.js": [
		"9b72",
		"chunk-1da5f9e4"
	],
	"./ion-chip.entry.js": [
		"830e",
		"chunk-5bc5d6d8"
	],
	"./ion-col_3.entry.js": [
		"2355",
		"chunk-2d0b2197"
	],
	"./ion-datetime_3.entry.js": [
		"80bf",
		"chunk-fa7e477e"
	],
	"./ion-fab_3.entry.js": [
		"d4db",
		"chunk-0de0d18c"
	],
	"./ion-img.entry.js": [
		"1fc1",
		"chunk-2d0b7239"
	],
	"./ion-infinite-scroll_2.entry.js": [
		"73af",
		"chunk-2d0d6cf7"
	],
	"./ion-input.entry.js": [
		"e40e",
		"chunk-58a2f238"
	],
	"./ion-item-option_3.entry.js": [
		"44a2",
		"chunk-3b9f7777"
	],
	"./ion-item_8.entry.js": [
		"50a7",
		"chunk-38e76e17"
	],
	"./ion-loading.entry.js": [
		"8f7a",
		"chunk-791a0390"
	],
	"./ion-menu_3.entry.js": [
		"7de8",
		"chunk-507b2f08"
	],
	"./ion-modal.entry.js": [
		"99f6",
		"chunk-a1278e32"
	],
	"./ion-nav_2.entry.js": [
		"8534",
		"chunk-ce70bb36"
	],
	"./ion-popover.entry.js": [
		"460a",
		"chunk-997b2b78"
	],
	"./ion-progress-bar.entry.js": [
		"7b50",
		"chunk-f03217bc"
	],
	"./ion-radio_2.entry.js": [
		"060f",
		"chunk-1a0a83e8"
	],
	"./ion-range.entry.js": [
		"c66f",
		"chunk-8bfb8276"
	],
	"./ion-refresher_2.entry.js": [
		"6670",
		"chunk-eaa59b64"
	],
	"./ion-reorder_2.entry.js": [
		"6113",
		"chunk-6ddc6d3e"
	],
	"./ion-ripple-effect.entry.js": [
		"ae45",
		"chunk-2d213a9b"
	],
	"./ion-route_4.entry.js": [
		"d235",
		"chunk-871c5bd0"
	],
	"./ion-searchbar.entry.js": [
		"4a45",
		"chunk-36da7a1a"
	],
	"./ion-segment_2.entry.js": [
		"2d92",
		"chunk-4955c11d"
	],
	"./ion-select_3.entry.js": [
		"f923",
		"chunk-f85a0498"
	],
	"./ion-slide_2.entry.js": [
		"3d48",
		"chunk-2d0c4dcb"
	],
	"./ion-spinner.entry.js": [
		"eb32",
		"chunk-ef9d0a30"
	],
	"./ion-split-pane.entry.js": [
		"4015",
		"chunk-2d0bfe96"
	],
	"./ion-tab-bar_2.entry.js": [
		"3a0b",
		"chunk-1bc73208"
	],
	"./ion-tab_2.entry.js": [
		"0670",
		"chunk-ce77f8b4"
	],
	"./ion-text.entry.js": [
		"d490",
		"chunk-7ddd577e"
	],
	"./ion-textarea.entry.js": [
		"e3ae",
		"chunk-e8429d14"
	],
	"./ion-toast.entry.js": [
		"1ee9",
		"chunk-40769a80"
	],
	"./ion-toggle.entry.js": [
		"10c2",
		"chunk-510c0e2f"
	],
	"./ion-virtual-scroll.entry.js": [
		"7f59",
		"chunk-2d0e26e9"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "722d";
module.exports = webpackAsyncContext;